import { dataOneToOneSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconOneToOneSolid = /*#__PURE__*/createIcon(dataOneToOneSolid)
export default IconOneToOneSolid
